import { makeStyles } from '@material-ui/styles';
import { MessageNotificationProps } from 'stream-chat-react';
import { Text, MainButton, ArrowDownLine } from '@bizzabo/design-system';

const MessageNotification: React.FC<MessageNotificationProps> = ({ onClick, showNotification }) => {
    const classes = useStyles();

    if (!showNotification) {
        return null;
    }

    return (
        <MainButton
            variant="fill"
            className={classes.notificationBtn}
            onClick={onClick}
            before={<ArrowDownLine title="arrow down" />}
        >
            <Text variant="t80" className={classes.text}>
                new messages
            </Text>
        </MainButton>
    );
};

const useStyles = makeStyles(
    theme => ({
        notificationBtn: {
            borderRadius: 36,
            padding: '4px 12px',
            backgroundColor: theme.palette.greys[700],
            boxShadow: '0px 4px 14px rgba(0, 0, 0, 0.1)',
            position: 'absolute',
            bottom: 14,
            left: '50%',
            transform: 'translateX(-50%)',
        },
        text: {
            lineHeight: 1,
        },
    }),
    {
        classNamePrefix: MessageNotification.name,
    }
);

export default MessageNotification;
